<template>
  <div>
    <DashFilters @filter-changed="onFilterChanged" />
    <div v-if="chartData && chartData.length">
      <DxChart
        v-if="chartData && chartData.length"
        :data-source="chartData"
        :title="$t('reporting.management_board.harvested_stage_overview')"
        palette="Soft"
      >
        <DxExport :enabled="true" />
        <DxArgumentAxis argument-type="string" />
        <DxValueAxis>
          <DxTitle :text="$t('common.hectares')" />
        </DxValueAxis>
        <DxSeries
          value-field="unharvested_area"
          argument-field="crop"
          :name="$t('reporting.management_board.unharvested_area')"
          type="stackedBar"
          color="#90caf9"
        />
        <DxSeries
          value-field="harvested_area"
          argument-field="crop"
          :name="$t('reporting.management_board.harvested_area')"
          type="stackedBar"
          color="#43a047"
        />
        <DxLegend vertical-alignment="bottom" horizontal-alignment="center" />
        <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" />
      </DxChart>
    </div>
    <div v-else style="margin-bottom: 30px">
      <span style="font-style: italic; color: red; font-weight: bold; margin-left: 20px;">
        {{ $t('common.no_data_found') }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { DxChart, DxSeries, DxArgumentAxis, DxValueAxis, DxLegend, DxTooltip, DxTitle, DxExport } from "devextreme-vue/chart";
import { DxSelectBox } from "devextreme-vue/select-box";
import DashFilters from "./DashFilters.vue";

export default {
  name: "HarvestedStage",
  components: {
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxValueAxis,
    DxLegend,
    DxTooltip,
    DxTitle,
    DxSelectBox,
    DxExport,
    DashFilters,
  },
  data() {
    return {
      chartData: [],
    };
  },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    ...mapActions({
      getHarvestedSurfaceReport: "works-parcels/getHarvestedSurfaceReport",
    }),
    customizeTooltip(info) {
      // info.point.data contains the full data object for the bar
      const data = info.point.data;
      const total = data.harvested_area + data.unharvested_area;
      return {
        html: `
        <strong>${data.crop}</strong><br>
        Total area: <b>${total}</b> ha<br>
        ${this.$t("reporting.management_board.harvested_area")}: <b>${data.harvested_area}</b> ha<br>
        ${this.$t("reporting.management_board.unharvested_area")}: <b>${data.unharvested_area}</b> ha
      `,
      };
    },
    onFilterChanged(filters) {
      this.getHarvestedSurfaceReportData(filters);
    },
    getHarvestedSurfaceReportData(filters) {
      if (!filters.season_uuid) return;
      const params = {
        season_uuid: filters.season_uuid,
        department_uuids: filters.departments,
        group_uuids: filters.groups,
      };
      this.getHarvestedSurfaceReport(params).then((response) => {
        // Assuming response contains the crop rotation data

        this.chartData = []; // Update with actual data from response

        if (response && Array.isArray(response)) {
          this.chartData = response.map((item) => ({
            crop: item.culture_uuid && item.culture ? item.culture.name : this.$t("common.unknown"),
            harvested_area: parseFloat(parseFloat(item.net_surface_worked).toFixed(2)),
            unharvested_area: parseFloat((parseFloat(item.total_surface) - parseFloat(item.net_surface_worked)).toFixed(2)),
          }));
        }
      });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.season_year_select {
  width: 250px;
  margin-top: 15px;
  margin-left: 15px;
  margin-bottom: 15px;
}
</style>
